import { render, staticRenderFns } from "./volume-profile-button.vue?vue&type=template&id=5e049b17&"
import script from "./volume-profile-button.vue?vue&type=script&lang=js&"
export * from "./volume-profile-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports